<div class="row box-order">
  <div class="col-xxl-12 col-sm-6 box-col-6">
    <app-balance-profile></app-balance-profile>
  </div>
  <div class="col-xxl-12 order-xxl-0 order-1">
    <app-portfolio></app-portfolio>
  </div>
  <div class="col-xxl-12 col-sm-6 box-col-6">
    <app-activities></app-activities>
  </div>
</div>
